import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface PerfRowItem {
  label: string;
  newCM: number;
  growth: string;
  newFunded: number;
  totalFunded: number;
  fundedCap: string;
  payout: string;
  payoutCMs: number;
  bg: string;
}

export interface PerformanceDetailModalProps {
  isOpen: boolean;
  closeModal: () => void;
  perfRows: PerfRowItem[];
}

export const PerformanceDetailModal: React.FC<PerformanceDetailModalProps> = ({
  isOpen,
  closeModal,
  perfRows
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const stop = (e: React.MouseEvent) => e.stopPropagation();

  return (
    <div
      onClick={closeModal}
      style={s(
        `position:fixed;inset:0;background:rgba(1,37,60,0.45);z-index:9999;display:flex;align-items:flex-start;justify-content:center;padding:8vh 16px;overflow-y:auto`
      )}
    >
      <div
        onClick={stop}
        style={s(
          `width:100%;max-width:960px;background:#fff;border-radius:14px;box-shadow:0 24px 64px rgba(1,37,60,0.3);overflow:hidden`
        )}
      >
        <div
          style={s(
            `display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:20px 24px;border-bottom:1px solid #EEF0F3`
          )}
        >
          <div style={s(`display:flex;flex-direction:column;gap:4px`)}>
            <span style={s(`font-size:18px;font-weight:700;color:#0F1B2D`)}>
              {t('managerNetwork.perfModal.title', 'Detailed Performance')}
            </span>
            <span style={s(`font-size:13px;color:#6B7280`)}>
              {t('managerNetwork.perfModal.desc', 'Monthly breakdown for the current filters. Calculated from stage history, funding and payout records.')}
            </span>
          </div>
          <button
            onClick={closeModal}
            style={s(
              `width:34px;height:34px;border-radius:8px;border:1px solid #E3E6EA;background:#fff;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;flex:none`
            )}
          >
            <i className="icon-x"></i>
          </button>
        </div>
        <div style={s(`overflow-x:auto`)}>
          <div style={s(`min-width:820px`)}>
            <div
              style={s(
                `display:grid;grid-template-columns:80px repeat(7,1fr);gap:8px;padding:10px 24px;background:#FAFAFB;font-size:11.5px;font-weight:600;color:#6B7280;text-transform:uppercase;letter-spacing:0.03em`
              )}
            >
              <span>{t('managerNetwork.perfModal.cols.month', 'Month')}</span>
              <span>{t('managerNetwork.perfModal.cols.newCm', 'New CM')}</span>
              <span>{t('managerNetwork.perfModal.cols.growth', 'Growth')}</span>
              <span>{t('managerNetwork.perfModal.cols.newFunded', 'New funded')}</span>
              <span>{t('managerNetwork.perfModal.cols.totalFunded', 'Total funded')}</span>
              <span>{t('managerNetwork.perfModal.cols.fundedCap', 'Funded capital')}</span>
              <span>{t('managerNetwork.perfModal.cols.verifiedPayout', 'Verified payout')}</span>
              <span>{t('managerNetwork.perfModal.cols.cmsPaid', 'CMs paid')}</span>
            </div>
            {perfRows?.map((m, m_idx) => (
              <React.Fragment key={m_idx}>
                <div
                  style={s(
                    `display:grid;grid-template-columns:80px repeat(7,1fr);gap:8px;padding:12px 24px;border-bottom:1px solid #F1F2F5;font-size:13.5px;background:${m.bg}`
                  )}
                >
                  <span style={s(`font-weight:600`)}>{m.label}</span>
                  <span>{m.newCM}</span>
                  <span>{m.growth}</span>
                  <span>{m.newFunded}</span>
                  <span>{m.totalFunded}</span>
                  <span>{m.fundedCap}</span>
                  <span style={s(`font-weight:600`)}>{m.payout}</span>
                  <span>{m.payoutCMs}</span>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
